// App-side delegate for `@heidi/patients/data`.
// isAuthenticated crosses the package seam as a plain boolean.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import {
  GET_PATIENT_DOCUMENT_DOWNLOAD_URL,
  useQueryPatientDocumentDownloadUrl as useQueryPatientDocumentDownloadUrlCore,
} from '@heidi/patients/data';

export { GET_PATIENT_DOCUMENT_DOWNLOAD_URL };

export function useQueryPatientDocumentDownloadUrl(
  patientProfileId: string | null | undefined,
  documentId: string | null | undefined,
  options?: { enabled?: boolean }
) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQueryPatientDocumentDownloadUrlCore(
    patientProfileId,
    documentId,
    options,
    isAuthenticated
  );
}
